export type UnitSystem = "metric" | "imperial";

const METRES_PER_FOOT = 0.3048;

export function metresToFeet(m: number): number {
  return m / METRES_PER_FOOT;
}

export function feetToMetres(ft: number): number {
  return ft * METRES_PER_FOOT;
}

export function isUnitSystem(v: unknown): v is UnitSystem {
  return v === "metric" || v === "imperial";
}
